var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-group ads-search"},[_c('label',{attrs:{"for":"contact-info-ads"}},[_vm._v(_vm._s(_vm.$ls.Components_Address_Label_AddressSearch))]),(!_vm.inAdsCouldNotBeLoaded)?_c('div',{attrs:{"id":_vm.adsId}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }